namespace GeniuzPOS.Administration {
    export interface PsConfigTypeRow {
        ConfigTypeId?: string;
        ConfigTypeName?: string;
        Description?: string;
        IsActive?: boolean;
    }

    export namespace PsConfigTypeRow {
        export const idProperty = 'ConfigTypeId';
        export const nameProperty = 'ConfigTypeId';
        export const localTextPrefix = 'Administration.PsConfigType';
        export const lookupKey = 'Administration.PsConfigType';

        export function getLookup(): Q.Lookup<PsConfigTypeRow> {
            return Q.getLookup<PsConfigTypeRow>('Administration.PsConfigType');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ConfigTypeId = "ConfigTypeId",
            ConfigTypeName = "ConfigTypeName",
            Description = "Description",
            IsActive = "IsActive"
        }
    }
}
